module.exports = "\r\nuniform sampler2D texture;\r\nuniform sampler2D matTexture;\r\n\r\nvarying vec3 f_position;\r\nvarying vec3 f_normal;\r\nvarying vec2 f_uv;\r\nvarying vec2 v_n;\r\n\r\nvoid main() {\r\n    vec3 color = texture2D(matTexture, v_n).rgb;\r\n    gl_FragColor = vec4(color, 1.0);\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/lit-frag.glsl
// module id = 15
// module chunks = 0